import { DataGrid } from "@msuite/ui/data-grid";
import { useTranslation } from "@msuite/ui/localization";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import React from "react";
import { TicketTypeIcon } from "@/components/cards";
import { NoteText } from "@/components/notes";
import { client } from "@/hono";

/** Props Interface */
interface TicketGeneralProps {
	ticketId: string;
}

export function TicketGeneral({ ticketId }: TicketGeneralProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { data: ticket } = useQuery({
		queryKey: ["tickets", ticketId],
		queryFn: async () => {
			const response = await client.tickets[":ticketId"].$get({
				param: { ticketId },
			});
			const data = await responseHandler(response);
			return data.ticket;
		},
	});

	/** Render */
	return (
		<React.Fragment>
			<DataGrid variant="border">
				<DataGrid.Row>
					<DataGrid.Label>ID</DataGrid.Label>
					<DataGrid.Value>{ticketId}</DataGrid.Value>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("projects.fields.number")}</DataGrid.Label>
					<DataGrid.Value>{guardString(ticket?.number)}</DataGrid.Value>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("general.type")}</DataGrid.Label>
					<DataGrid.Cell>
						<TicketTypeIcon
							ticketTypeId={guardString(ticket?.type)}
							withLabel
							className="*:text-base!"
						/>
					</DataGrid.Cell>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("general.description")}</DataGrid.Label>
					<DataGrid.Value>{guardString(ticket?.description)}</DataGrid.Value>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("notes.note")}</DataGrid.Label>
					<DataGrid.Cell>
						<NoteText note={guardString(ticket?.note)} />
					</DataGrid.Cell>
				</DataGrid.Row>
			</DataGrid>
		</React.Fragment>
	);
}
